<template>
    <div class="form-group">
        <label v-if="label" :for="name">{{label}}</label>
        <flat-pickr class="form-control" :id="name" :name="name" v-model="model[name]" :placeholder="placeholder"
            :disabled="disabled" :config="config" @on-change="onChange" />
        <small class="form-text text-danger" v-if="errors[name]" v-text="errors[name][0]" />
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import {
        Arabic
    } from 'flatpickr/dist/l10n/ar.js';

    export default {
        props: {
            label: {
                type: String
            },

            name: {
                type: String,
                required: true
            },

            model: {
                type: [Object, Array],
                required: true
            },

            errors: {
                type: [Object, Array],
                required: true
            },

            disabled: {
                type: Boolean,
            },

            options: {
                type: Object
            }

        },

        components: {
            flatPickr
        },

        computed: {
            placeholder() {
                return `${this.Lang.get('messages.select')} ${this.label}`;
            },

            config() {
                return {
                    ...this.options,
                    locale: Arabic
                };
            }
        },
        
        methods: {
            onChange(value) {                
                this.$emit('change', value);
            }
        }
    };

</script>

<style>
</style>
